import React, { Component } from 'react';

export class MomentMaster extends Component {
    constructor(props) {
        super(props);
        this.state = { items: [], loading: true, editItem: null, form: {}, uploading: false };
    }

    componentDidMount() { this.load(); }

    load() {
        this.setState({ loading: true });
        fetch('api/moment?includeInactive=1')
            .then(r => r.ok ? r.json() : [])
            .then(items => this.setState({ items, loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    openAdd() { this.setState({ editItem: { id: 0 }, form: { image: '', caption: '', sort: this.state.items.length, flag: 1 } }); }
    openEdit(item) { this.setState({ editItem: item, form: { ...item } }); }
    closeModal() { this.setState({ editItem: null }); }

    upd(field, val) { this.setState({ form: { ...this.state.form, [field]: val } }); }

    async uploadImage() {
        var input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.onchange = async (e) => {
            if (!e.target.files[0]) return;
            this.setState({ uploading: true });
            var fd = new FormData();
            fd.append('file', e.target.files[0]);
            fd.append('folder', 'moment');
            try {
                var r = await fetch('api/programplus/upload', { method: 'POST', body: fd });
                var res = await r.json();
                this.upd('image', res.path);
            } catch {}
            this.setState({ uploading: false });
        };
        input.click();
    }

    async save() {
        var { form, editItem } = this.state;
        if (!form.image) { alert('กรุณาอัปโหลดรูปภาพ'); return; }
        var body = { id: editItem.id || 0, image: form.image, caption: form.caption || '', sort: parseInt(form.sort) || 0, flag: form.flag === 0 ? 0 : 1 };
        try {
            var r = await fetch('api/moment', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
            if (!r.ok) throw new Error('save failed');
            this.closeModal();
            this.load();
        } catch (e) { alert('บันทึกไม่สำเร็จ: ' + e.message); }
    }

    async del(item) {
        if (!window.confirm('ต้องการลบภาพนี้หรือไม่?')) return;
        try {
            var r = await fetch('api/moment/' + item.id, { method: 'DELETE' });
            if (!r.ok) throw new Error('delete failed');
            this.load();
        } catch (e) { alert('ลบไม่สำเร็จ: ' + e.message); }
    }

    async toggleActive(item) {
        var body = { ...item, flag: item.flag === 1 ? 0 : 1 };
        await fetch('api/moment', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
        this.load();
    }

    render() {
        var { items, loading, editItem, form, uploading } = this.state;

        return (
            <div style={{ padding: 20 }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <p style={{ margin: 0, fontSize: 13, color: '#888' }}>ทั้งหมด {items.length} รายการ</p>
                    <button className="btn btn-danger" onClick={() => this.openAdd()}><i className="fas fa-plus"></i> เพิ่มภาพ</button>
                </div>

                {loading ? (
                    <div className="text-center py-5"><div className="spinner-border text-danger"></div></div>
                ) : items.length === 0 ? (
                    <div className="text-center py-5" style={{ color: '#bbb' }}>
                        <i className="fas fa-camera" style={{ fontSize: 48, display: 'block', marginBottom: 12 }}></i>
                        ยังไม่มีภาพประทับใจ
                    </div>
                ) : (
                    <div className="row">
                        {items.map(m => (
                            <div key={m.id} className="col-md-4 col-lg-3 mb-4">
                                <div style={{ background: '#fff', borderRadius: 10, overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.08)', opacity: m.flag === 0 ? 0.5 : 1 }}>
                                    <div style={{ position: 'relative', background: '#f5f5f5' }}>
                                        <img src={m.image} alt="" style={{ width: '100%', height: 180, objectFit: 'cover', display: 'block' }} />
                                        <span style={{ position: 'absolute', top: 8, left: 8, background: 'rgba(0,0,0,0.7)', color: '#fff', padding: '3px 10px', borderRadius: 20, fontSize: 11 }}>#{m.sort}</span>
                                        {m.flag === 0 && <span style={{ position: 'absolute', top: 8, right: 8, background: '#6c757d', color: '#fff', padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600 }}>Inactive</span>}
                                    </div>
                                    <div style={{ padding: 12 }}>
                                        {m.caption && <div style={{ fontSize: 13, color: '#555', marginBottom: 8, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', minHeight: 32 }}>{m.caption}</div>}
                                        <div className="d-flex justify-content-between align-items-center">
                                            <button className="btn btn-sm btn-outline-secondary" onClick={() => this.toggleActive(m)}>
                                                <i className={m.flag === 1 ? 'fas fa-pause' : 'fas fa-play'}></i> {m.flag === 1 ? 'ปิด' : 'เปิด'}
                                            </button>
                                            <div className="d-inline-flex" style={{ gap: 8 }}>
                                                <button className="btn btn-sm btn-outline-primary" onClick={() => this.openEdit(m)}><i className="fas fa-edit"></i></button>
                                                <button className="btn btn-sm btn-outline-danger" onClick={() => this.del(m)}><i className="fas fa-trash"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {editItem && (
                    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => this.closeModal()}>
                        <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: '90%', maxWidth: 600, maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
                            <h5 style={{ marginBottom: 16 }}>{editItem.id ? 'แก้ไข' : 'เพิ่ม'}ภาพประทับใจ</h5>

                            <div className="mb-3">
                                <label style={{ fontSize: 13, fontWeight: 600 }}>รูปภาพ *</label>
                                <div onClick={() => this.uploadImage()} style={{ width: '100%', height: 220, border: '2px dashed #ccc', borderRadius: 8, cursor: 'pointer', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafafa' }}>
                                    {form.image ? <img src={form.image} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : (
                                        <div style={{ textAlign: 'center', color: '#999' }}>
                                            <i className="fas fa-cloud-upload-alt fa-2x"></i>
                                            <div style={{ marginTop: 8, fontSize: 13 }}>{uploading ? 'กำลังอัปโหลด...' : 'คลิกเพื่ออัปโหลดรูป'}</div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="mb-3">
                                <label style={{ fontSize: 13, fontWeight: 600 }}>คำบรรยาย</label>
                                <input className="form-control" value={form.caption || ''} onChange={e => this.upd('caption', e.target.value)} placeholder="เช่น ฮ่องกง - ฮ่องกง" />
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label style={{ fontSize: 13, fontWeight: 600 }}>ลำดับ</label>
                                    <input type="number" className="form-control" value={form.sort || 0} onChange={e => this.upd('sort', e.target.value)} />
                                </div>
                                <div className="col-md-6">
                                    <label style={{ fontSize: 13, fontWeight: 600 }}>สถานะ</label>
                                    <select className="form-select" value={form.flag || 1} onChange={e => this.upd('flag', parseInt(e.target.value))}>
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                </div>
                            </div>

                            <div className="d-flex justify-content-end" style={{ gap: 8 }}>
                                <button className="btn btn-outline-secondary" onClick={() => this.closeModal()}>ยกเลิก</button>
                                <button className="btn btn-danger" onClick={() => this.save()}><i className="fas fa-save"></i> บันทึก</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
